import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { ApplicationStateService } from "../services/application-state.service";

@Injectable({ providedIn: 'root' })
export class EtagInterceptor implements HttpInterceptor {
  private ifNoneMatchHeaderKey = 'If-None-Match';
  private etagHeaderKey = 'ETag';

  constructor(private applicationStateService: ApplicationStateService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const uriWithQueryParams = request.urlWithParams;

    const existingCachedDataWithEtag: { etag: string, data: any } = this.applicationStateService.getCachedDataWithEtag(uriWithQueryParams);

    const modifiedRequest = existingCachedDataWithEtag?.etag && existingCachedDataWithEtag?.data
      ? request.clone({
        headers: request.headers.set(this.ifNoneMatchHeaderKey, existingCachedDataWithEtag.etag),
      })
      : request;

    return next.handle(modifiedRequest).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const responseEtag = event.headers.get(this.etagHeaderKey);

          if (responseEtag) {
            this.applicationStateService.setCachedDataWithEtag(uriWithQueryParams, responseEtag, event.body);
          }
        }
      }),
      catchError(err => {
        if (err.status === 304 && existingCachedDataWithEtag?.data) {
          return of(new HttpResponse({ status: 200, body: existingCachedDataWithEtag.data }));
        }

        return throwError(() => err);
      })
    );
  }
}
